export default "__VITE_ASSET__qVVfA0nn__"